import { Switch as CssModulesSwitch, SwitchProps } from '@sunwebgroup/uds-ui/switch'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/switch' instead.
 */
const StyledSwitch = styled(CssModulesSwitch)<SwitchProps>``

export default StyledSwitch
